export default __webpack_public_path__ + "static/media/search.da9fdc90.svg";